import React from "react";
import { Link, Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import IconButton from "@material-ui/core/IconButton";
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MoreIcon from "@material-ui/icons/MoreVert";
import firebase, { auth, db, storage } from "../../settings/firebase";
import getQueryStrings from '../../utils/getQueryStrings';
import { GoogleIcon, TwitterIcon, FacebookIcon, TiktokIcon, YoutubeIcon, NoteIcon } from '../../components/SVG/SnsIcon';
import InstagramIcon from '../../img/instagram.png';
import './Settings.css';
import Divider from "@material-ui/core/Divider";
import Follow from "../../components/Follow";
import MultilineText from "../../components/MultilineText";
import { deletenotification } from "../../function/sendnotification";

const useStyles = makeStyles((theme) => ({
  notificationread: {
    backgroundColor: "#888888",
  },
  notificationitem: {
    display: "flex",
    flexDirection: "row",
  },
  notificationitemdiv: {
    width: "90vw",
    textAlign: "left",
  },
  barIcon: {

  }
}))

// 通知リスト
function NotificationItem (props) {
  const { data, changeRead, index, deleteItem } = props;
  const classes = useStyles;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleOptionMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOptionMenuClose = () => {
    setAnchorEl(null);
  };

  const deleteNotice = () => {
    const user = firebase.auth().currentUser;
    if (user !== null) {
      deletenotification(user.uid, data.docId, "");
      deleteItem(index);
    }
    handleOptionMenuClose();
  }

  const renderOptionMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id="accountMenu"
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      disableScrollLock={ true }
      open={isMenuOpen}
      onClose={handleOptionMenuClose}
    >
      <MenuItem onClick={() => {changeRead(index, !data.read); handleOptionMenuClose()}}>{data.read? <>未読にする</>: <>既読にする</>}</MenuItem>
      <MenuItem onClick={() => {deleteNotice()}}>削除する</MenuItem>
    </Menu>
  );

  return (
    <div
      className={data.read? classes.notificationread: classes.notification}
      style={data.read? 
          {justifyContent: "center", display: "flex", textAlign: "center", backgroundColor: "#dddddd",}
        : {justifyContent: "center", display: "flex", textAlign: "center", backgroundColor: "#ffffff",}
        }
    >
      <div className={classes.notificationitem} style={{display: "flex", alignItems: "center", maxWidth: "1000px", width: "90vw"}}>
        <Avatar alt={data.fromdisplayid} src={data.fromphotourl}></Avatar>
        <div className={classes.notificationitemdiv}
          style={{textAlign: "left", marginLeft: "1em", flexGrow: "1"}}
        >
          <p><MultilineText>{data.body}</MultilineText></p>
          <p>{data.fromname}</p>
        </div>
        {data.type === "follow" || data.type === "like"?
          <Follow followuid={data.fromuid} />
        : null}
        <IconButton
          edge="end"
          className={classes.barIcon}
          aria-label="option of current user"
          aria-haspopup="true"
          onClick={handleOptionMenuOpen}
        >
          <MoreIcon className={classes.iconCircle} />
        </IconButton>
        {renderOptionMenu}
      </div>
      <Divider />
    </div>
  )
}

// 通知一覧画面
export default class Notifications extends React.Component {
  constructor(props) {
    super(props);
    const query = window.location.search;
    let redirect = "/";
    if (query) {
      const queries = getQueryStrings(query);
      redirect = queries["redirect"];
    }
    this.state = {
      redirect: decodeURIComponent(redirect),
      open: false,
      snackmessage: "",
      data: [],
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.changeReadState = this.changeReadState.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.alertClose = this.alertClose.bind(this);
  }

  _isMounted = false;

  // 現在の通知を読み込む
  async componentDidMount() {
    const user = auth.currentUser;
    if (user !== null) {
      await db.collection("messages").doc(user.uid).collection("notifications")
      .orderBy("receivedAt", "desc").get().then((docs) => {
        let data = [];
        docs.forEach(doc => {
          if (doc.exists) {
            let item = doc.data();
            item.docId = doc.id;
            data.unshift(item);
            this.changeReadState(0, true, false, data);
          }
        })
        this.setState({data: data});
        console.log(user.uid, data);
      })
    }
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async changeReadState(index, change=true, reset=true, data=this.state.data) {
    if (data[index] !== undefined) {
      const user = auth.currentUser;
      if (user !== null && change !== data[index]["read"]) {
        await db.collection("messages").doc(user.uid).collection("notifications").doc(data[index].docId).update({
          read: change
        })
        if (reset) {
          data[index]["read"] = change;
          this.setState({data: data});
        }
      }
    }
  }

  deleteItem(index) {
    let data = this.state.data;
    data.splice(index, 1);
    this.setState({data: data});
  }

  // 情報ポップアップの表示
  popupinfo = (text) => {
    this.setState({open: true, snackmessage: text});
  }

  // 情報ポップアップの非表示
  alertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({open: false});
  };

  render() {
    let list = [];
    let keynum = 0
    this.state.data.forEach(item => {
      list.unshift(<NotificationItem key={'notif-' + keynum} data={item} changeRead={this.changeReadState} index={keynum} deleteItem={this.deleteItem} />);
      keynum += 1;
    })
    // console.log(this.state)
    return (
      <>
        <div className={"inputarea-center"}>
          <div className={"inputarea-center-div"}>
            <h3 style={{fontWeight: "700", margin: "5px 5px 5px 1em", maxWidth: "1000px", width: "90vw"}}>お知らせ</h3>
            <div style={{width: "90vw"}}></div>
          </div>
          <Divider />
        </div>
        {list}
        <div style={{height: "20px"}} />
        <Button
          component={Link}
          to={this.state.redirect === "/" ? "/" : decodeURIComponent(this.state.redirect)}
          fullWidth
          variant="contained"
          color="secondary"
          className={"cancelSettingsBtn"}
        >
          戻る
        </Button>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={this.state.open}
          autoHideDuration={4000}
          onClose={this.alertClose}
          message={this.state.snackmessage}
          action={
            <React.Fragment>
              <IconButton size="small" aria-label="close" color="inherit" onClick={this.alertClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
        >
        </Snackbar>
      </>
    )
  }
}